import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { toDate } from 'date-fns-tz';
import Flag from 'components/Flag';
import { getCountry } from 'products/nomad_insurance/assets/data/countries';
import useCurrencies from 'products/nomad_insurance/hooks/useCurrencies';
import {
  CLAIM_TYPES,
  STEP_PATHS
} from 'products/nomad_insurance/views/ClaimsForm/consts';
import SectionHeading from '../SectionHeading';
import PreEx from '../PreEx';
import { SummarySection, SummaryField, SummaryBox } from '../../styled';

const DateHeading = ({ claimType }) => {
  if (claimType === CLAIM_TYPES.TRAVEL) {
    return <b>Date of event</b>;
  }
  return <b>First date of service</b>;
};

DateHeading.propTypes = {
  claimType: PropTypes.string
};

const DescriptionHeading = ({ claimType }) => {
  if (claimType === CLAIM_TYPES.TRAVEL) {
    return <b>Please describe what happened, and what you would like to claim</b>;
  }
  return <b>Tell us what happened</b>;
};

DescriptionHeading.propTypes = {
  claimType: PropTypes.string
};

const Info = ({
  claimType,
  dateOfService,
  incidentCity,
  incidentCountry,
  claimCurrency,
  claimAmount,
  startComment,
  happenedComment
}) => {
  const currencies = useCurrencies();
  const hasPreEx = startComment?.length > 0;

  return (
    <SummarySection>
      <SectionHeading
        link={`/nomad-insurance/claim/${claimType}/${STEP_PATHS.TRAVEL_INFORMATION}`}
      >
        {claimType === CLAIM_TYPES.TRAVEL ? 'Travel information' : 'Medical information'}
      </SectionHeading>
      <SummaryField>
        <DateHeading claimType={claimType} />
        <div>
          {format(
            toDate(dateOfService, {
              timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
            }),
            'dd MMMM yyyy'
          )}
        </div>
      </SummaryField>
      <SummaryField>
        <b>Country</b>
        <div>
          <Flag code={incidentCountry} /> {getCountry(incidentCountry)}
        </div>
      </SummaryField>
      <SummaryField>
        <b>City</b>
        <div>{incidentCity}</div>
      </SummaryField>
      <SummaryField>
        <div>
          <b>Currency</b> (billed)
        </div>
        <div>{currencies.find((x) => x.value === claimCurrency)?.label}</div>
      </SummaryField>
      <SummaryField>
        <div>
          <b>Claim amount</b>
        </div>
        <div>{claimAmount}</div>
      </SummaryField>
      <PreEx claimType={claimType} hasPreEx={hasPreEx} startComment={startComment} />
      <SummaryField>
        <div>
          <DescriptionHeading claimType={claimType} />
        </div>
        <SummaryBox>{happenedComment}</SummaryBox>
      </SummaryField>
    </SummarySection>
  );
};

Info.propTypes = {
  claimType: PropTypes.string.isRequired,
  dateOfService: PropTypes.string.isRequired,
  incidentCity: PropTypes.string.isRequired,
  incidentCountry: PropTypes.string.isRequired,
  claimCurrency: PropTypes.string.isRequired,
  claimAmount: PropTypes.string.isRequired,
  startComment: PropTypes.string.isRequired,
  happenedComment: PropTypes.string.isRequired
};

export default Info;
